
export const MANAGE_GAME = "Game Type"
export const SAVE_GAME = "Save Game"